const SYSTEM_NAME = 'new_jounery_h5'

/** 缓存数据时用到的 Key */
export class CacheKey {
  static TOKEN = `${SYSTEM_NAME}-token-key`
}
